<py-modal
  [title]="'areaOfUse.excludeArticlesModal_title' | cxTranslate"
  [showCancelButton]="true"
  [cancelButtonText]="'common.cancel_action' | cxTranslate"
  [centered]="true"
  [scrollable]="true"
  [actions]="templateActions"
  [cxFocus]="focusConfig"
  (scrolledToBottom)="nextScrollIndex()"
  (esc)="closeModal('escape pressed')"
>
  <ng-container
    *ngIf="
      {
        articles: articles$ | async,
      } as data;
      else loading
    "
  >
    <ng-container *ngIf="data.articles; else loading">
      <py-checkbox [showLabel]="true">
        <input type="checkbox" [checked]="allArticlesSelected" (change)="toggleSelectAll()" />
        <span slot="label">
          {{ 'common.selectAll_heading' | cxTranslate }}
        </span>
      </py-checkbox>
      <div class="border-top mt-2">
        <div *ngFor="let article of data.articles.slice(0, pagination.currentScrollIndex)" class="d-flex border-bottom pt-2 pb-2">
          <div class="d-flex align-items-center mr-3">
            <py-checkbox>
              <input type="checkbox" [checked]="articleSelected(article.code)" (change)="toggleSelectArticle(article.code)" />
            </py-checkbox>
          </div>
          <py-article-image
            [images]="!!article.image ? [article.image] : []"
            [altText]="article?.displayName"
            class="mr-2"
          ></py-article-image>
          <py-article-info [article]="article"></py-article-info>
        </div>
      </div>
    </ng-container>
  </ng-container>
</py-modal>

<ng-template #templateActions>
  <py-action-button
    [buttonClass]="'btn btn-primary'"
    [type]="'button'"
    [buttonLabel]="'common.save_action' | cxTranslate"
    [disabled]="allArticlesExcluded"
    (click)="save()"
  >
  </py-action-button>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center pb-16">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
